import { ListedAlarmsMessage } from "./ListedAlarmsMessage";
export default ListedAlarmsMessage;
